import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CommentSectionUtility.css';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface Comment {
  id: number;
  display_name: string;
  text: string;
  created_at: string;
}

interface CommentSectionProps {
  sectionId: number;
}

interface FormState {
  name: string;
  email: string;
  text: string;
}

export const CommentSection: React.FC<CommentSectionProps> = ({ sectionId }) => {
  const [comments, setComments] = useState<Comment[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [form, setForm] = useState<FormState>({
    name: '',
    email: '',
    text: '',
  });

  // Fetch comments
  useEffect(() => {
    axios
      .get<Comment[]>(`${backendUrl}/worlddata/comments/get-comments/${sectionId}/`)
      .then((res) => setComments(res.data))
      .catch((err) => console.error('Error fetching comments:', err));
  }, [sectionId]);

  // Submit comment
  const submitComment = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null); // reset

    try {
      const res = await axios.post<Comment>(`${backendUrl}/worlddata/comments/create-comment/`, {
        section_id: sectionId,
        ...form,
      });

      setComments((prev) => [res.data, ...prev]);
      setForm({ name: '', email: '', text: '' });
    } catch (err: any) {
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError('Something went wrong. Please try again.');
      }
    }
  };

  return (
    <div className="comment-section">
      <h2>Comments</h2>
      {error && <div className="comment-error">{error}</div>}
      <form onSubmit={submitComment}>
        <input type="text" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />

        <input type="email" placeholder="Email (We don't store your email 🛡️)" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />

        <textarea placeholder="Write a comment..." value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} required />

        <button type="submit">Post Comment</button>
      </form>

      <div className="comments-list">
        {comments.map((c) => (
          <div key={c.id} className="comment">
            <strong>{c.display_name}</strong>
            <p>{c.text}</p>
            <small>{new Date(c.created_at).toLocaleString()}</small>
          </div>
        ))}
      </div>
    </div>
  );
};
